import styled from 'styled-components';
import { flexCenter } from '@anm/styles/helpers';
import Background from '@anm/components/Background';

const Wrapper = styled.div`
  display: flex;
  flex: 1;
  ${Background} {
    ${flexCenter};
    text-align: center;
    flex-direction: column;
    color: #fff;
    line-height: 32px;
    border: 1px solid #ccdde6;
    border-radius: 10px;
    box-shadow: 0 2px 10px rgb(1 83 130 / 10%);
    padding: 30px;
    width: 100%;
  }
`;

export const FreePlanTitle = styled.div`
  font-size: 16px;
`;

export const FreePlanDescription = styled.p`
  font-size: 24px;
  font-weight: 800;
  margin: 10px 0 20px;
`;

export default Wrapper;
